import React, { Component } from "react";
import { Link } from "react-router-dom";

class TravelDashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "All",
    };
  }

  renderStatus(status) {
    const map = {
      Draft: ["#F1F5F9", "#475569"],
      Approved: ["#ECFDF3", "#027A48"],
      "Booking In Progress": ["#EEF4FF", "#1464E9"],
      "Pending Approval": ["#FFF7E6", "#B76E00"],
      "Cash Advance Pending": ["#FFF7E6", "#C2410C"],
      Rejected: ["#FEECEC", "#B42318"],
      Completed: ["#F1F5F9", "#475569"],
    };

    const [bg, color] = map[status] || map.Draft;

    return <span style={{ background: bg, color, padding: "5px 10px", borderRadius: 20, fontSize: 12, fontWeight: 900 }}>{status}</span>;
  }

  renderCard(label, value, sub, color) {
    return (
      <div style={summaryCard}>
        <div style={{ display: "flex", gap: 14, alignItems: "center" }}>
          <div style={{ ...iconBox, background: color }} />
          <div>
            <div style={cardLabel}>{label}</div>
            <div style={cardValue}>{value}</div>
            <div style={cardSub}>{sub}</div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const rows = [
      ["TR-2023-0018", "Allistair Lorenzo James", "Corporate Strategy", "Simpleview Summit 2023", "Houston, USA", "19/04/2023 - 01/05/2023", "Air", "22,480.00", "10,000.00", "Approved"],
      ["TR-2023-0017", "Nurul Aisyah Binti Rahman", "Marketing", "ITB Asia 2023", "Singapore", "10/05/2023 - 13/05/2023", "Air", "3,860.00", "2,000.00", "Booking In Progress"],
      ["TR-2023-0016", "Mohd Hafiz Bin Ismail", "Operations", "Partner Engagement", "Kuala Lumpur", "22/05/2023 - 23/05/2023", "Vehicle", "420.00", "0.00", "Pending Approval"],
      ["TR-2023-0015", "Diana Wong Siew Mei", "Finance", "Finance Workshop", "Kuala Lumpur", "15/05/2023 - 16/05/2023", "Train", "680.00", "300.00", "Approved"],
      ["TR-2023-0014", "Richard Lau Kim Hong", "Business Development", "Sales Mission", "Jakarta, Indonesia", "05/04/2023 - 07/04/2023", "Air", "2,950.00", "2,000.00", "Cash Advance Pending"],
      ["TR-2023-0013", "Siti Fatimah Binti Abdul", "Human Resources", "HR Conference", "Bangkok, Thailand", "28/04/2023 - 30/04/2023", "Air", "2,750.00", "1,500.00", "Rejected"],
      ["TR-2023-0012", "Allistair Lorenzo James", "Corporate Strategy", "Industry Training", "Kuala Lumpur", "03/03/2023 - 04/03/2023", "Train", "560.00", "0.00", "Completed"],
      ["TR-2023-0011", "Amelia Roziman", "Finance", "Budget Planning Workshop", "Kuching", "12/03/2023 - 13/03/2023", "Vehicle", "320.00", "0.00", "Draft"],
    ];

    const filteredRows =
      this.state.activeTab === "All"
        ? rows
        : rows.filter((row) => row[9] === this.state.activeTab);

    return (
      <div style={{ padding: 24 }}>
        <div style={header}>
          <div>
            <h3 style={{ margin: 0, color: "#0F172A", fontWeight: 900 }}>Travel & Budget</h3>
            <p style={{ margin: "6px 0 0", color: "#64748B", fontSize: 13 }}>
              Submit and track travel requests, bookings, cash advances, approvals, and travel-related records.
            </p>
          </div>

          <Link to="/travel/create" style={primaryButton}>
            + Create Travel Request
          </Link>
        </div>

        <div style={notice}>
          <b style={{ color: "#1464E9", marginRight: 10 }}>i</b>
          Process flow: Manager/Supervisor approval first, Admin proceeds with bookings after approval,
          then Finance proceeds with payment after booking confirmations.
        </div>

        <div style={summaryGrid}>
          {this.renderCard("My Trips", 18, "View all", "#DBEAFE")}
          {this.renderCard("Draft", 6, "View all", "#EEF4FF")}
          {this.renderCard("Pending Approval", 7, "View all", "#FFF7E6")}
          {this.renderCard("Approved", 12, "View all", "#ECFDF3")}
          {this.renderCard("Booking In Progress", 5, "View all", "#F3E8FF")}
          {this.renderCard("Cash Advance Pending", 3, "View all", "#FEF3C7")}
          {this.renderCard("Rejected", 2, "View all", "#FEECEC")}
        </div>

        <div style={tableCard}>
          <div style={tabs}>
            {["All", "Draft", "Pending Approval", "Approved", "Booking In Progress", "Cash Advance Pending", "Rejected", "Completed"].map((tab) => (
              <button
                key={tab}
                onClick={() => this.setState({ activeTab: tab })}
                style={{
                  ...tabButton,
                  color: this.state.activeTab === tab ? "#DC111C" : "#475569",
                  borderBottom:
                    this.state.activeTab === tab
                      ? "2px solid #DC111C"
                      : "2px solid transparent",
                }}
              >
                {tab}
              </button>
            ))}
          </div>

          <div style={filterGrid}>
            <input placeholder="Search request ID or purpose..." style={inputStyle} />
            <select style={inputStyle}><option>All Statuses</option></select>
            <select style={inputStyle}><option>All Departments</option></select>
            <select style={inputStyle}><option>All Modes</option></select>
            <input value="01/03/2023 - 31/05/2023" readOnly style={inputStyle} />
            <button style={secondaryButton}>Filters</button>
          </div>

          <div style={{ overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ background: "#F8FAFC" }}>
                  {["Request ID", "Employee Name", "Department", "Purpose", "Destination", "Travel Dates", "Transport Mode", "Estimated Cost (RM)", "Cash Advance (RM)", "Status", "Action"].map((h) => (
                    <th key={h} style={thStyle}>{h}</th>
                  ))}
                </tr>
              </thead>

              <tbody>
                {filteredRows.map((row) => (
                  <tr key={row[0]} style={{ borderTop: "1px solid #E5E7EB" }}>
                    <td style={tdStyle}>
                      <Link to={`/travel/${row[0]}`} style={{ color: "#1464E9", fontWeight: 900, textDecoration: "none" }}>
                        {row[0]}
                      </Link>
                    </td>
                    <td style={tdStyle}>{row[1]}</td>
                    <td style={tdStyle}>{row[2]}</td>
                    <td style={tdStyle}>{row[3]}</td>
                    <td style={tdStyle}>{row[4]}</td>
                    <td style={tdStyle}>{row[5]}</td>
                    <td style={tdStyle}>{row[6]}</td>
                    <td style={{ ...tdStyle, textAlign: "right" }}>{row[7]}</td>
                    <td style={{ ...tdStyle, textAlign: "right" }}>{row[8]}</td>
                    <td style={tdStyle}>{this.renderStatus(row[9])}</td>
                    <td style={tdStyle}>•••</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div style={{ padding: 16, color: "#64748B", fontSize: 12 }}>
            Showing {filteredRows.length === 0 ? 0 : 1} to {filteredRows.length} of {filteredRows.length} entries
          </div>
        </div>
      </div>
    );
  }
}

const header = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "flex-start",
  marginBottom: 18,
};

const primaryButton = {
  background: "#DC111C",
  color: "#fff",
  padding: "10px 16px",
  borderRadius: 8,
  textDecoration: "none",
  fontWeight: 900,
  fontSize: 13,
};

const notice = {
  background: "#EAF3FF",
  border: "1px solid #BFDBFE",
  borderRadius: 10,
  padding: "13px 16px",
  marginBottom: 18,
  fontSize: 13,
  color: "#334155",
};

const summaryGrid = {
  display: "grid",
  gridTemplateColumns: "repeat(7, minmax(0, 1fr))",
  gap: 14,
  marginBottom: 20,
};

const summaryCard = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  padding: 16,
  minHeight: 90,
  minWidth: 0,
};

const iconBox = {
  width: 42,
  height: 42,
  borderRadius: 12,
  flexShrink: 0,
};

const cardLabel = {
  fontSize: 12,
  color: "#334155",
  fontWeight: 900,
};

const cardValue = {
  fontSize: 25,
  fontWeight: 900,
  color: "#0F172A",
  marginTop: 4,
};

const cardSub = {
  fontSize: 12,
  color: "#64748B",
};

const tableCard = {
  background: "#fff",
  border: "1px solid #E5E7EB",
  borderRadius: 12,
  overflow: "hidden",
  marginBottom: 16,
};

const tabs = {
  display: "flex",
  gap: 24,
  padding: "13px 18px 0",
  borderBottom: "1px solid #E5E7EB",
  overflowX: "auto",
};

const tabButton = {
  background: "transparent",
  border: 0,
  padding: "0 0 12px",
  fontSize: 13,
  fontWeight: 900,
  cursor: "pointer",
  whiteSpace: "nowrap",
};

const filterGrid = {
  display: "grid",
  gridTemplateColumns: "2fr 1fr 1fr 1fr 1.4fr auto",
  gap: 12,
  padding: 16,
};

const inputStyle = {
  height: 38,
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "0 12px",
  fontSize: 13,
  outline: "none",
  background: "#fff",
};

const secondaryButton = {
  background: "#fff",
  border: "1px solid #CBD5E1",
  borderRadius: 8,
  padding: "9px 14px",
  fontWeight: 800,
};

const thStyle = {
  padding: "12px 14px",
  textAlign: "left",
  fontWeight: 900,
  color: "#334155",
  fontSize: 12,
  whiteSpace: "nowrap",
};

const tdStyle = {
  padding: "12px 14px",
  color: "#334155",
  fontSize: 13,
  verticalAlign: "middle",
  whiteSpace: "nowrap",
};

export default TravelDashboard;